import { useCallback } from 'react';

import { SelectionList } from '../../../../../common';

import type { MedicalSelectionGroupProps } from './types';

export default function MedicalSelectionGroup({
  label, addButtonLabel, placeholder, selectionType, values,
  selections, disabled, isSaving, onAdd, onDelete,
}: MedicalSelectionGroupProps) {
  const entries = selections.filter((entry) => entry.selection_type === selectionType)
    .map((entry) => ({ id: entry.id, value: entry.value ?? '' }));
  const hasNone = entries.some((entry) => entry.value === 'None');
  const hasOther = entries.some((entry) => entry.value !== 'None');
  const add = useCallback((value: string) => onAdd(selectionType, value), [onAdd, selectionType]);
  const remove = useCallback((id: number) => onDelete(selectionType, id), [onDelete, selectionType]);

  return (
    <SelectionList
      addButtonLabel={addButtonLabel}
      disabled={disabled}
      entries={entries}
      error={entries.length === 0 || (hasNone && hasOther) || entries.some((entry) => !values.includes(entry.value))}
      getDeleteConfirm={(entry) => ({ title: 'Confirm deletion?', message: `Delete "${entry.value}"?` })}
      isSaving={isSaving}
      label={label}
      onAdd={add}
      onDelete={remove}
      options={values.filter((value) => !(value === 'None' && hasOther) && !(hasNone && value !== 'None')).map((value) => ({ label: value, value }))}
      placeholder={placeholder}
      required
    />
  );
}
